import { shuffle } from 'lodash'

// Ghost-text search examples rotated through the input's placeholder when NLP
// college search is enabled.
export const nlpPlaceholderOptions = shuffle([
  'Selective schools with early decision rounds',
  'Liberal arts colleges in the northeast',
  'Top nursing schools',
  'Schools in the SEC',
  'Schools where I can study abroad',
  'Schools that consider demonstrated interest',
])